import React, { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { GlobalToken } from 'antd';

import { SpinCentered } from '@/comp';
import { useStores } from '@/hooks/use-stores';
import { useNavigate, useLocation } from 'react-router-dom';
import { EPButton } from '@/components';

const EulaPage = observer(() => {
  const { t } = useTranslation();
  const { eulaStore, userStore } = useStores();
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: '/' } };

  const onAccept = async () => {
    const acceptedEula = {
      eulaId: eulaStore.eula.id,
      agreed: 'true',
    };

    await eulaStore.accept(acceptedEula);
    userStore.setEulaField(true);
    navigate(from, { replace: true });
  };

  const onDecline = () => {
    userStore.signOut();
  };

  useEffect(() => {
    eulaStore.get();
  }, []);

  return (
    <Container>
      {eulaStore.isReady ? (
        <div className="license-box">
          <div className="license-box-header">{t('License Agreement')}</div>
          <div className="license-box-content">{eulaStore.eulaFile}</div>
          <div className="license-box-buttons">
            <EPButton className="decline-button" onClick={onDecline}>
              {t('Decline')}
            </EPButton>
            <EPButton type="primary" onClick={onAccept}>
              {t('Accept')}
            </EPButton>
          </div>
        </div>
      ) : (
        <SpinCentered />
      )}
    </Container>
  );
});

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  height: 100%;
  width: 100%;
  align-items: center;

  .license-box {
    display: flex;
    flex-direction: column;
    padding: ${({ theme: { token } }) => token.paddingMD}px;
    position: absolute;
    top: 20%;
    left: 20%;
    height: 60%;
    width: 60%;
    color: ${({ theme: { token } }) => token.colorBgContainer};
    background-color: ${({ theme: { token } }) => token.colorText};
    border-radius: 4px;

    .license-box-header {
      color: ${({ theme: { token } }) => token.colorBgContainer};
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    }

    .license-box-content {
      padding-top: ${({ theme: { token } }) => token.paddingXS}px;
      flex-grow: 1;
      overflow: scroll;
    }
  }

  .license-box-buttons {
    padding-top: ${({ theme: { token } }) => token.padding}px;
    text-align: center;
    justify-content: center;

    .decline-button {
      margin-right: ${({ theme: { token } }) => token.marginSM}px;
    }
  }
`;

export default EulaPage;
